import React, {Component} from 'react';
import {Row, Col, Form, ControlLabel, FormControl} from "react-bootstrap";
import ReactNotify from 'react-notify';
import DefinicjaGodzinyStartowejKopiowanieForm from "../components/DefinicjaGodzinyStartowejKopiowanieForm";
import TrasyService from "../../../trasyConfig/trasy/TrasyService";
import RodzajKalendarzyService from "../../kalendarze/rodzajeKalendarzy/RodzajKalendarzyService";
import DefinicjaGodzinyStartowejService from "../DefinicjaGodzinyStartowejService";
import {TopAlertOstrzezenie, TopAlertSukces} from "../../../../../componentsTopsa/alerty/TopAlerts";
import DefinicjaGodzinyStartowejTable from "../components/DefinicjaGodzinyStartowejTable";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import FormGroup from "react-bootstrap/es/FormGroup";
import {TopButtonAdd} from "../../../../../componentsTopsa/buttons/TopButtons";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import EkipyService from "../../../zasobyConfig/ekipy/definicjaEkipy/EkipyService";

export default class DGSKopiowanieTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasy:[],
            kalendarze:[],
            czySkopiowano:false,
            czyBylPrzycisk:false,
            godziny:null,
            dane:null,
            godzina_wybrana: '',
            validatorMessages: [],
            ekipy:[]
        };

        this.pobierzTrasy = this.pobierzTrasy.bind(this)
        this.pobierzRodzajeKalendarzy = this.pobierzRodzajeKalendarzy.bind(this)
        this.onClickKopiuj = this.onClickKopiuj.bind(this)
        this.pokazDodaneGodziny = this.pokazDodaneGodziny.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onEdycjaGodziny = this.onEdycjaGodziny.bind(this)
        this.onChangeNowaGodzina = this.onChangeNowaGodzina.bind(this)
        this.onClickDodajNowa = this.onClickDodajNowa.bind(this)
    }

    componentDidMount(){
        this.pobierzTrasy()
        this.pobierzRodzajeKalendarzy()
        this.getEkipy()
    }

    getEkipy(){
        EkipyService.getEkipy().then(function (response) {
            this.setState({ekipy:response.data.content})
        }.bind(this))
    }


    pobierzTrasy(){
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy:response.data.content})
        }.bind(this))
    }

    pobierzRodzajeKalendarzy(){
        RodzajKalendarzyService.getKalendarze().then(function (response) {
            this.setState({kalendarze:response.data.content})
        }.bind(this))
    }

    onClickKopiuj(data,params){

        this.setState({czyBylPrzycisk:true, czySkopiowano:false, godziny:null, dane:null})

        DefinicjaGodzinyStartowejService.getProceduraKopiujGodziny(params).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie skopiowano godziny startowe', "", 3000)
                this.setState({czyBylPrzycisk:false, czySkopiowano:true, dane:data})
                this.pokazDodaneGodziny(data)
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas kopiowania godzin', "", 3000)
                this.setState({czySkopiowano:false})

            }
        }.bind(this))

    }

    pokazDodaneGodziny(data){
        DefinicjaGodzinyStartowejService.getGodzinyWTrasieIKalendarzu(data.idTrNa, data.idRkNa).then(function (response) {
            this.setState({godziny: response.data})
        }.bind(this))
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc godzinę: ' + obj.godz1p)) {
            DefinicjaGodzinyStartowejService.deleteGodzina(obj.idTrk).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto godzinę', "", 3000)
                    this.pokazDodaneGodziny(this.state.dane)
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania godziny', "", 3000)
                }
            }.bind(this))

        }
    }

    onEdycjaGodziny(obj) {
        DefinicjaGodzinyStartowejService.editGodzina(obj.idTrk, obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie edytowano godzinę', "", 3000)
                this.pokazDodaneGodziny(this.state.dane)
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas edycjii godziny', "", 3000)
            }
        }.bind(this))
    }

    onChangeNowaGodzina(e) {
        this.setState({godzina_wybrana: e.target.value})
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickDodajNowa() {

        let poprawne = true; this.state.validatorMessages = [];

        if(!Boolean(this.state.dane)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano trasy i kalendarza')
        }

        if(!Boolean(this.state.godzina_wybrana)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wpisano godziny')
        }

        if(poprawne){

                this.setState({validatorMessages: []})


                let data = {
                    "godz1p": parseFloat((this.state.godzina_wybrana).replace(':', '.')),
                    "idRk": this.state.dane.idRkNa,
                    "idTr": this.state.dane.idTrNa
                }


                DefinicjaGodzinyStartowejService.addGodzina(data).then(function (response) {
                    if (response.status < 300) {
                        this.refs.notificator.success('Pomyślnie dodano godzinę', "", 3000)
                        this.pokazDodaneGodziny(this.state.dane)
                    }
                    else {
                        this.refs.notificator.error('Wystąpił błąd podczas dodawania godziny', "", 3000)
                    }
                }.bind(this))

                this.setState({godzina_wybrana: ''})
                document.getElementById('InputNowaGodzina').value = '';


        }
    }

    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <Row>
                    <Col sm={12}>
                        <DefinicjaGodzinyStartowejKopiowanieForm trasy={this.state.trasy} kalendarze={this.state.kalendarze} handleClickKopiuj={this.onClickKopiuj}/>
                    </Col>
                    <Col sm={12}>
                        {
                            Boolean(this.state.czySkopiowano)?
                                <div>
                                    <TopAlertSukces text={'Pomyślnie skopiowano godziny startowe'}/>
                                    <DefinicjaGodzinyStartowejTable data={this.state.godziny}
                                                                    trasy={this.state.trasy}
                                                                    kalendarze={this.state.kalendarze}
                                                                    handleUsun={this.onClickUsun}
                                                                    handleEdycjaGodziny={this.onEdycjaGodziny}
                                                                    ekipy={this.state.ekipy}
                                    />
                                    <Row>
                                        <Col sm={12}>
                                            <TopIf isTrue={Boolean(this.state.dane)}>
                                                <Row>
                                                    <Col xs={12} md={8} mdOffset={4} lg={6} lgOffset={6}>
                                                        <div style={{marginTop: '15px'}}>
                                                            <Form horizontal={true}>
                                                                <FormGroup>
                                                                    <Col xs={12} sm={6} lg={4}>
                                                                    </Col>
                                                                    <Col xs={12} sm={6} lg={4}>
                                                                        <ControlLabel>Godzina</ControlLabel>
                                                                        <FormControl type={'time'} onChange={this.onChangeNowaGodzina} id={'InputNowaGodzina'}/>
                                                                    </Col>
                                                                    <Col xs={12} sm={6} lg={4}>
                                                                        <div className={'add-label-margin'}></div>
                                                                        <TopButtonAdd onClick={this.onClickDodajNowa} text={'Dodaj godzinę'}/>
                                                                    </Col>
                                                                </FormGroup>
                                                                <FormGroup>
                                                                    <ValidatorMessages messages={this.state.validatorMessages}/>
                                                                </FormGroup>
                                                            </Form>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </TopIf>
                                            <div style={{height: '15px'}}></div>
                                        </Col>
                                    </Row>
                                </div>
                                :
                                ''
                        }
                        {
                            (!Boolean(this.state.czySkopiowano) && Boolean(this.state.czyBylPrzycisk))?
                                <TopAlertOstrzezenie text={'Kopiowanie godzin zakończyło się niepowodzeniem'}/>
                                :
                                ''
                        }
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/definicjeGodzinStartowychjDlaTrasy/DGSKopiowanieTab/DGSKopiowanieTab.js